import React from 'react'

import * as style from './style.module.sass'

type CategoryChildHeroProps = {
  title: string
}

const CategoryChildHero: React.FC<CategoryChildHeroProps> = ({ title }) => (
  <h1 className={style.title}>{title}</h1>
)

export default CategoryChildHero
